var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 377,
    viewBox: "0 0 377 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 188.5,
    r: 188.5,
    fill: "#EBC335"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 142C67 142 131.999 91 154.249 91C176.5 91 198.654 142 225.577 142C252.5 142 302 91 302 91",
    stroke: "black",
    strokeWidth: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 286C67 286 131.999 235 154.249 235C176.5 235 198.654 286 225.577 286C252.5 286 302 235 302 235",
    stroke: "black",
    strokeWidth: 17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 214C67 214 131.999 163 154.249 163C176.5 163 198.654 214 225.577 214C252.5 214 302 163 302 163",
    stroke: "black",
    strokeWidth: 17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e8b3fdc26f3e068c438300a01be02f17.svg";
export { ForwardRef as ReactComponent };